import { HISTORY_PREFIX } from './menuSearchHistory'

const db = {
  save(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  get(key, defaultValue = {}) {
    return JSON.parse(localStorage.getItem(key)) || defaultValue
  },
  remove(key) {
    localStorage.removeItem(key)
  },
  clear() {
    // 退出时仅保留按账号隔离的菜单查询历史，其余登录及业务缓存照常清理。
    try {
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i)
        if (key && !key.startsWith(HISTORY_PREFIX)) localStorage.removeItem(key)
      }
    } catch (error) {
      // 浏览器禁用存储时不影响退出登录。
    }
  }
}

export default db
